module.exports = "<span data-ng-message=required>*An asset name is required</span> ";